import React from "react";
import PropTypes from "prop-types";
import "./StatisticsCards.css";
import TransparentLoader from "../Loaders/TransparentLoader";
import BilingualText from "../BilingualText/BilingualText";

const StatisticsCards = ({ stats, loading = false }) => {
	const formatValue = (value, format = "number") => {
		if (value === null || value === undefined) return "0";
		switch (format) {
			case "currency":
				return `₹${parseFloat(value).toLocaleString("en-IN")}`;
			case "percentage":
				return `${parseFloat(value).toFixed(2)}%`;
			case "number":
			default:
				return typeof value === "number" ? value.toLocaleString("en-IN") : value;
		}
	};

	return (
		<div className="row">
			{stats.map((stat, index) => (
				<div className={`col-xl-${12 / stats.length} col-sm-6`} key={index}>
					<div className="card stat-card">
						<div className="card-body">
							<div className={`media align-items-center ${stat.icon ? "" : "text-center"}`}>
								{stat.icon && (
									<div className={`stat-icon bg-${stat.color || "primary"}-light text-${stat.color || "primary"} me-3`}>
										<i className={stat.icon}></i>
									</div>
								)}
								<div className="media-body">
									<TransparentLoader show={loading} />
									<>
										<h2 className={`fs-38 text-black font-w600 ${stat.className || ""}`}>
											{formatValue(stat.value, stat.format)}
										</h2>
										<span className="fs-16">
											{stat.titleKey ? (
												<BilingualText translationKey={stat.titleKey} />
											) : (
												stat.title
											)}
										</span>
										{(stat.subtitle || stat.subtitleKey) && (
											<p className="text-muted mb-0 mt-1">
												{stat.subtitleKey ? (
													<BilingualText translationKey={stat.subtitleKey} />
												) : (
													stat.subtitle
												)}
											</p>
										)}
									</>
								</div>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

StatisticsCards.propTypes = {
	stats: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			titleKey: PropTypes.string,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			format: PropTypes.oneOf(["number", "currency", "percentage"]),
			className: PropTypes.string,
			subtitle: PropTypes.string,
			subtitleKey: PropTypes.string,
			icon: PropTypes.string,
			color: PropTypes.string,
		})
	).isRequired,
	loading: PropTypes.bool,
};

export default StatisticsCards;
